import { render, staticRenderFns } from "./Green.vue?vue&type=template&id=0c9e54ea&scoped=true"
import script from "./Green.vue?vue&type=script&lang=ts"
export * from "./Green.vue?vue&type=script&lang=ts"
import style0 from "./Green.vue?vue&type=style&index=0&id=0c9e54ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e54ea",
  null
  
)

export default component.exports